/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Order_Vat_LabelInputs */

const vi_order_vat_label = /** @type {(inputs: Order_Vat_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`VAT ${i?.percent}%`)
};

/**

* @param {Order_Vat_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_vat_label = /** @type {((inputs: Order_Vat_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Vat_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_vat_label(inputs)
});